export const TranslationsTH = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: 'ระบบสั่งอาหารออนไลด์',
        cart: 'รายการที่สั่ง',
        open_24: 'เปิด 24 ชั่วโมง',
        closed: 'ปิด',
        free: 'ฟรี',
        something_went_wrong: 'มีสิ่งผิดพลาดเกิดขึ้น',
        try_again: 'กรุณาลองใหม่อีกครั้ง',
    },
    constants: {
        calendar: {
            days: {
                monday: 'วันจันทร์',
                tuesday: 'วันอังคาร',
                wednesday: 'วันพุธ',
                thursday: 'วันพฤหัส',
                friday: 'วันศุกร์',
                saturday: 'วันเสาร์',
                sunday: 'วันอาทิตย์',
            },
        },
        services: {
            pickup: 'มารับสินค้า',
            delivery: 'ให้ส่งสินค้า',
            dine_in: 'รับประทานภายในร้าน',
            table_booking: 'สำรองโต๊ะ',
        },
        payment: {
            method: {
                cash: 'เงินสด',
                card: 'บัตรเงินสด',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                custom: 'Custom',
            },
            backend_method: {
                cash: 'เงินสด',
                card: 'บัตรเงินสด',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                custom: 'Custom',
            },
            status: {
                success: 'ชำระเงินเรียบร้อยแล้ว',
                pending: 'อยู่ระหว่างดำเนินการ',
                error: 'มีข้อผิดพลาด',
                refunded: 'การคืนเงิน',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'ลบ',
                drop_here: 'วางไฟล์ของคุณที่นี่หรือคลิกเพื่อเลือก',
                accepts: 'ยอมรับ {{fileTypes}} ไฟล์',
                errors: {
                    max_files: 'จำนวนไฟล์ที่สามารถรองรับได้คือ {{number}} ',
                    max_size: 'ขนาดของไฟล์ที่สามารถรองรับได้คือ {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "ขณะนี้ร้านอาหารปิดทำการอยู่ ลูกค้าไม่สามารถสั่งอาหารเพื่อรับประทานในขณะนี้ได้  กรุณาสั่งใหม่โดยเลือกวันและเวลาอื่นแทน",
            },
            buttons: {
                order: {
                    book_order: "จองโต๊ะ / สั่งอาหารออนไลด์",
                    order_online: "สั่งอาหารออนไลด์",
                    book_table: "จองโต๊ะ",
                    order: "สั่งอาหาร",
                    book: "ทำรายการจอง",
                    cart: "รายการที่สั่ง",
                    restart: "เริ่มรายการใหม่",
                    closed: "ร้านอาาหรปิด",
                    not_accepting: "ปิดรับการสั่งอาหาร",
                },
            },
        },
        modals: {
            auth: {
                login: "เข้าระบบ",
                register: "ลงทะเบียน",
                register_commence: "ดำเนินการต่อ",
                register_complete: "สร้างบัญชี",
                register_confirmation_sent: "รหัสยืนยันถูกส่งไปยังที่อยู่อีเมลของคุณ กรุณาใส่ระหัสยืนยันด้านล่างเพื่อทำรายการต่อ",
                register_confirmation_resent: "รหัสยืนยันถูกส่งอีกครั้ง  กรุณาตรวจสอบในจดหมายขยะของคุณหรือเริ่มกระบวนการใหม่",
                register_restart: "เริ่มรายการใหม่",
                register_resend_code: "ส่งระหัสยืนยันอีกรอบ",
                login_placeholder: "อีเมลล์",
                password_placeholder: "ระหัสผ่าน",
                confirm_password_placeholder: "ยืนยันระหัสผ่าน",
                confirmation_code_placeholder: "อีเมลล์ระหัสยืนยัน",
                accept_terms: "กรุณายอมรับข้อกำหนดและเงื่อนไข",
                accept_terms_view: "ดู",
                login_facebook: "เข้าระบบโดยใช้ Facebook",
                login_google: "เข้าระบบโดยใช้ Google",
                benefits: "เข้าสู่ระบบหรือสร้างบัญชีเพื่อบันทึกรายการอาหารทั้งหมดที่คุณทำการสั่ง",
                logged_in: "ลงชื่อเข้างานสำเร็จ",
                logged_out: "ออกจากระบบ",
                password_reset: {
                    init_button: "ส่งอีเมล์รีเพื่อทำการเซ็ตรหัสผ่าน",
                    init_success: "ลิงก์สำหรับทำการเซ็ตรหัสใหม่ได้ถูกส่งไปยังอีเมลของคุณแล้ว",
                    complete_button: "รีเซ็ทระหัสผ่าน",
                    complete_success: "ระหัสผ่านใหม่ได้ถูกแกไขเรียบร้อยแล้ว กรุณาเข้าระบบโดยใช้ระหัสผ่านตัวใหม่",
                    forgot_password_text: "ลืมระหัสผ่าน? ",
                    forgot_password_link: "แก้ไขระหัสผ่าน",
                    remember_password_text: "คุณต้องการจะจำระหัสผ่านไหม? ",
                    remember_password_link: "ย้อนกลับ",
                    invalid_title: "ระหัสผ่านที่ถูกรีเซ็ตไม่ถูกต้อง",
                    invalid_description: "ลิงก์การขอรีเซ็ตรหัสผ่านนี้ไม่ถูกต้อง ต้องทำการขอใหม่",
                    invalid_link: "กลับไปหน้าที่เข้าสู่ระบบ",
                    title: "ระหัสผ่านได้ถูกรีเซ็ท",
                    description: "ใส่ระหัสผ่านชุดใหม่สำหรับบัญชีขอบคุณ",
                },
                error_generic: "มีความผิดพลาดบางอย่างเดิดขึ้น กรุณาลองทำอีกครั้ง หรือ ติดต่อเรา",
                error_accept_terms: "กรุณายอมรับข้อกำหนดและเงื่อนไข",
                error_password_length: "รหัสผ่านขั้นต่ำ 6 ตัวอักษรและตัวเลข",
                error_social: "มีความผิดพลาดบางอย่างเดิดขึ้น กรุณาลองทำอีกครั้ง หรือ ติดต่อเรา",
                error_confirmation_code: "รหัสยืนยันไม่ถูกต้อง",
                error_invalid_code: "รหัสยืนยันไม่ถูกต้อง",
                error_exists: "ชื่อบัญชีนี้มีผู้ใช้แล้ว",
                error_invalid_email_pass: "อีเมลล์ หรือ ระหัสผ่านไม่ถูกต้อง",
                error_password_no_match: "ระหัสผ่านที่กรอกไม่เหมือนกัน",
                error_user_not_found: "ไม่มีบัญชีสำหรับผู้ที่ใช้อีเมล์นี้",
                error_invalid_email: "อีเมลล์ไม่ถูกต้อง",
                error_invalid_reset_token: "ลิงก์การขอรีเซ็ตรหัสผ่านนี้ไม่ถูกต้อง ต้องทำการขอใหม่",
            },
            booking: {
                form: {
                    name: "ฃื่อ และ นามสกุล",
                    email: "อีเมลล์",
                    phone: "หมายเลขโทรศัพท์",
                    number_of_people: "จำนวนคนที่จะจอง",
                    number_of_people_max: "จำนวนคนที่มากที่สุดที่จองได้คือ ({{max_people}} คน)",
                    number_of_people_min: "จำนวนคนขึ้นต่ำที่สามารถจองได้คือ ({{min_people}} คน)",
                    number_of_people_max_min: "จำนวนคนตั้นแต่ (Between {{min_people}} ถึง {{max_people}} คน)",
                    notes: "โน๊ต / คำขอพิเศษ",
                    submit: "ส่งคำขอการจอง",
                    email_optional: "(ไม่บังคับ)",
                    date: "วันที่",
                    duration: "ระยะเวลา",
                    seating: "เวลาที่ว่าง",
                    number_of_guests: "จำนวนแขก",
                    notes_placeholder: "อาการแพ้ โอกาสพิเศษ ที่นั่งที่ต้องการ",
                    reserving: "กำลังจอง...",
                    reserve_table: "จองโต๊ะ",
                    please_choose_a_date_and_time: "โปรดเลือกวันที่และเวลา",
                    invalid_people: "จำนวนคนต้องอยู่ระหว่าง {{min}} ถึง {{max}}",
                    party_size_max_fallback: "จำนวนสูงสุดที่อนุญาต",
                    loading_available_times: "กำลังโหลดเวลาที่ว่าง…",
                    select_a_date_to_see_available_times: "เลือกวันที่เพื่อดูเวลาที่ว่าง",
                    no_times_available_for_this_date: "ไม่มีเวลาว่างสำหรับวันที่นี้ โปรดเลือกวันอื่น",
                    shift: "รอบ",
                    service_times: "เวลาให้บริการ",
                    new_shift: "รอบใหม่",
                    time: "ช่วงเวลา",
                    times: "ช่วงเวลา",
                    unavailable: "ไม่ว่าง",
                    available: "ว่าง",
                    required_name: "โปรดกรอกชื่อของคุณ",
                    required_phone: "โปรดกรอกหมายเลขโทรศัพท์",
                    required_email: "โปรดกรอกอีเมล",
                    invalid_email: "โปรดกรอกอีเมลที่ถูกต้อง",
                    required_terms: "โปรดยอมรับข้อกำหนดก่อนจอง",
                    missing_custom_fields: "โปรดตอบคำถามที่จำเป็นทั้งหมด",
                    reservation_is_unavailable: "ไม่สามารถจองได้",
                    please_contact_the_restaurant_directly: "โปรดติดต่อร้านโดยตรง",
                    almost_done: "เกือบเสร็จแล้ว",
                    your_details: "ข้อมูลของคุณ",
                    tell_us_who_s_coming: "บอกเราว่าใครจะมาเพื่อให้เรายืนยันการจองได้",
                    book_your_table: "จองโต๊ะของคุณ",
                    choose_a_time_that_works_for_you: "เลือกเวลาที่สะดวกสำหรับคุณ",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "ส่งคำขอจอง แล้วร้านจะจัดการที่เหลือให้",
                    select_date: "เลือกวันที่",
                    standard: "มาตรฐาน",
                    minutes: "นาที",
                    next: "ถัดไป →",
                    back: "← ย้อนกลับ",
                    accept_terms: "ฉันยอมรับข้อกำหนดและเงื่อนไข",
                    info_1: "คุณจะได้รับอีเมลแจ้งเตือนเมื่อการจองของคุณได้รับการคอนเฟิร์มหรือปฏิเสธจากทางร้าน",
                },
                errors: {
                    not_found: "ไม่มีการจองเกิดขึ้น การจองอาจถูกลบไป",
                    generic: "มีความผิดพลาดบางอย่างเดิดขึ้น กรุณาลองทำอีกครั้ง หรือ ติดต่อเรา",
                    something_went_wrong: "มีข้อผิดพลาดบางอย่างเกิดขึ้น",
                    accept_terms: "กรุณายอมรับข้อกำหนดและเงื่อนไข",
                    required_phone: "กรุณากรอกหมายเลขโทรศัพท์",
                    required_email: "กรุณากรอกอีเมลล์",
                    required_name: "กรุณากรอกชื่อ",
                    invalid_email: "กรุณากรอกอีเมลล์ที่ถูกต้อง",
                    invalid_phone: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
                    invalid_people: "จำนวนของจำนวนคนที่ต้องการจองไม่ถูกต้อง",
                    booking_capacity_threshold: "เวลานี้เต็มแล้ว โปรดลองเวลาอื่น",
                    slot_unavailable: "จำนวนคนนี้เต็มแล้ว โปรดลองเวลาอื่น",
                    booking_date_paused: "การจองสำหรับวันที่นี้ถูกหยุดชั่วคราว โปรดเลือกวันอื่น",
                    invalid_table_assignment: "โต๊ะเหล่านี้รองรับกลุ่มของคุณไม่ได้ โปรดเลือกเวลาอื่น",
                    exceeded_order_limit: "มีคำขอจองมากเกินไป โปรดลองใหม่ภายหลัง",
                    validation_failed_recaptcha_v3: "ตรวจพบการเข้าชมที่ผิดปกติ คุณใช้ VPN อยู่หรือไม่? โปรดทำการยืนยันด้านบนแล้วลองอีกครั้ง",
                    validation_failed_recaptcha_v2: "ไม่สามารถเริ่มการจองได้ โปรดลองอีกครั้งหรือใช้วิธีอื่น หากคุณใช้ VPN ให้ลองปิดก่อน",
                    booking_already_exists: "การจองนี้ถูกส่งไปแล้ว ตรวจสอบอีเมลหรือเปิดลิงก์การจองของคุณ",
                    invalid_party_size: "โปรดเลือกจำนวนคนที่ถูกต้อง",
                    invalid_request: "คำขอไม่ถูกต้อง โปรดรีเฟรชหน้าแล้วลองอีกครั้ง",
                    table_booking_unavailable: "ไม่สามารถจองโต๊ะได้",
                },
            },
            cart: {
                title: "รายการที่สั่ง",
                proceed_to_checkout: "ไปหน้าชำระเงิน",
                edit_dish: "แก้ไข",
                remove_dish: "ลบ",
                no_items_1: "ไม่มีรายการใดที่สั่ง",
                no_items_2: "กรุณาเลือกรายการใดๆ เพื่อดำเนินการต่อ",
                free_delivery_notice: "จัดส่งอาหารโดยไม่เสียค่าบริการในกรณีที่มีการสั่งอาหารเกินจำนวน {{value, currency}}",
                errors: {
                    min_order_promo: "รายการที่สั่งขึ้นต่ำคือ {{value, currency}} ก่อนที่สามารถใช้ร่วมกับโปรโมชั่นตัวนี้ได้",
                    min_order_delivery: "รายการที่สั่งขึ้นต่ำคือ {{value, currency}} ก่อนที่จะใช้บริการจัดส่งอาหาร",
                },
                promo: {
                    heading: "ระหัสโปรโมชั่น",
                    placeholder: "กรุณาใส่ระหัสโปรโมชั่น",
                    add: "ใส่ระหัส",
                    title: "โปรโมชั่นชื่อ {{name}} ได้ถูกบันทึกในรายการ",
                    fixed_discount: "ลดราคาจำนวน {{value, currency}}",
                    percent_discount: "ลดราคาจำนวน {{value}}%",
                    added_to_cart: "โปรโมชั่นได้ถูกบันทึกในรายการสั่งอาหารแล้ว",
                    errors: {
                        not_found: "ไม่พบโปรโมชัน",
                        disabled: "โปรโมชั่นถูกยกเลิกไปแล้ว",
                        not_available: "ไม่สามารถใช้โปรโมชั่นได้ในขณะนี้",
                        logged_in_only: "คุณจะต้องทำการเช้าระบบก่อนที่จะใช้โปรโมชั่นนี้",
                        already_used: "คุณได้ทำการใช้โปรโมชั่นนี้ไปแล้ว",
                        invalid: "โปรโมชั่นนี้ไม่สามารถใช้ได้",
                        invalid_service: "โปรโมชั่นนี้ไม่สามารถใช้ได้ในบริการที่คุณเลือก",
                        later_only: "สามารถใช้ได้ในกรณีที่การสั่งล่วงหน้าเท่านั้น",
                        now_only: "สามารถใช้ได้ในกรณีที่มีการสั่งอาหารรับประทานในขณะนี้ ไม่สามารถใช้ในการสั่งอาหารล่วงหน้าได้",
                        generic: "Oops... มีความผิดพลาดเกิดขึ้นและได้มีการบันทึกการผิดพลาดไว้แล้ว",
                        dishes_required_multi: "ท่านสามมารถใช้โปรโมชั่นนี้ได้กับการสั่งอาหารบางชนิดเท่านั้น",
                        dishes_required_single: "อาหารที่เข้าร่วมกับโปรโมชั่นนี้คือ '{{dish}}'",
                    },
                },
                tip: {
                    title: "ทิป",
                    placeholder: "ใส่จำนวนทิป",
                },
            },
            checkout: {
                title: "หน้าชำระเงิน",
                subtitle: "กรุณาตรวจสอบรายการอาหารต่าง ๆ ให้ถูกต้อง",
                details: {
                    service: "บริการ",
                    due: "กำหนด",
                    due_now_asap: "เดี๋ยวนี้ / เร็วที่สุดเท่าที่จะทำได้",
                    address: "ที่อยู่ที่จะให้ไปส่ง",
                    total: "ยอดรวม",
                    table: "โต๊ะ",
                    store_location: "ที่อยู่ของร้าน",
                },
                customer: {
                    title: "ลูกค้า",
                    subtitle: "เข้าระบบเพื่อทำการบันทึกรายการอาหารที่สั่งและรายละเอียดต่างๆ",
                    button: "เข้าระบบ",
                    name: "ชื่อ และ นามสกุล",
                    email: "อีเมลล์",
                    phone: "หมายเลขโทรศัพท์",
                    phone_important: "หมายเลขโทรศัพท์ (สำคัญ)",
                    notes: "หมายเหตุการสั่งซื้อ",
                    delivery_notes: "คำแนะนำในการจัดส่ง / หมายเหตุการสั่งซื้อ",
                    optional: "ไม่บังคับ"
                },
                payment: {
                    title: "วิธีการชำระเงิน",
                },
                accept_terms: "ยอมรับข้อกำหนดและเงื่อนไข",
                accept_terms_view: "ดูรายละเอียด",
                processing_order: "ประมวลผลการสั่งอาหาร",
                warning: {
                    different_payment_currency: "ทางร้านอาหารใช้เงินสกุล {{store_currency}} แต่ในการชำระเงิน รับเป็นเงินสกุล {{payment_currency}}",
                    closing_soon: "ร้านจะปิดบริการในไม่ช้า, ลูกค้าสามาถทำรายการได้ภายใน {{value}} นาที",
                    closed: "ขออภัยขณะนี้ร้านปิดแล้ว เราไม่สามารถรับออร์เดอร์ของคุณได้ในวันนี้",
                    expired: "ทางร้านไม่สามารถทำตามคำสั่งซื้อของคุณในเวลาที่คุณเลือก โปรดเลือกวันที่หรือเวลาใหม่",
                },
                errors: {
                    stripe_generic: "บัตรเครดิตการ์ดมีปัญหา กรุณาใช้ช่องทางการชำระเงินแบบอื่น",
                    stripe_loading_fail: "เกิดข้อผิดพลาดในการชำระเงิน กรุณาลองใหม่อีกครั้ง",
                    something_went_wrong: "เกิดข้อผิดพลาดบางประการเกิดขึ้น",
                    paypal_generic: "เกิดข้อผิดพลาดกับ PayPal, กรุณาลองใหม่อีกครั้ง หรือเลื่อกช่องทางในการชำระเงินแบบอื่น",
                    payment_fail: "การชำระเงินไม่ประสบความสำเร็จ กรุณาใช้ช่องทางการชำระเงินแบบอื่น",
                    payment_cancelled: "การชำระเงินถูกยกเลิก กรุณาใช้ช่องทางการชำระเงินแบบอื่น",
                    payment_error: "เกิดข้อผิดพลาดในการดำเนินการชำระเงินออนไลด์ กรุณาใช้ช่องทางการชำระเงินแบบอื่น",
                    payment_declined: "วิธีการชำระเงินของคุณไม่ประสบความสำเร็จ",
                    card_declined: "บัตรเครดิตการ์ดของคุณมีปัญหา ไม่สามารถใช้ในการชำระเงินได้",
                    promo_max_uses_exceeded: "รหัสโปรโมชันนี้ถึงขีดจำกัดการใช้งานแล้วและไม่สามารถใช้ได้อีกต่อไป",
                    store_closed: "ร้านอาหารของเราปิดแล้ว และไม่สามารถรับออร์เดร์ได้ในขณะนี้",
                    accept_terms: "กรุณายอมรับยอมรับข้อกำหนดและเงื่อนไข",
                    required_payment: "กรุณาเลือกวิธีชำระเงิน",
                    required_phone: "กรุณากรอกหมายเลขโทรศัพท์ของท่าน",
                    required_email: "กรุณากรอกอีเมลล์ของท่าน",
                    required_name: "กรุณากรอกชื่อของท่าน",
                    invalid_email: "กรุณากรอกอีเมลล์ให้ถูกต้อง",
                    invalid_phone: "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
                    invalid_cc_number: "หมายเลขเครดิตการ์ดไม่ถูกต้อง",
                    retry_cc_number: "เกิดข้อผิดพลาดขึ้นบางประการ กรุณากรอกหมายเลขบัตรเครดิตการ์ดใหม่และลองชำระอีกครั้ง",
                    closed: "ขณะนี้ร้าน ปิด / กำลังจะปิด และไม่สามารถรับออเดอร์อีกได้",
                    promo_login_required: "คุณต้องเข้าระบบก่อนจึงจะสามารถใช้โปรโมชั่นได้",
                    promo_used: "โปรโมชั่นนี้ได้ถูกใช้ไปแล้ว",
                },
                button: {
                    continue: "ดำนินการต่อเพื่อชำระเงิน",
                    place_order: "ทำการสั่งอาหารr",
                },
            },
            customer: {
                age_v: {
                    title: "การยืนยันอายุ",
                    required_for_items: "ใช้ในการสั่งซื้อในรายการบางชนิด",
                    min_age: "อายุขึ้นต่ำ: {{age}} ปี",
                    est_time: "ระยะเวลาทีใช้ในการยืนยันสถานะ: {{time}} ชั่วโมง",
                    upload_description: "อับโหลดบัตรประจำตัวของท่านด้านล่างเพื่อใช้ในการยืนยันสถานะอายุ. คุณจะได้รับการแจ้งจากเราโดยอีเมลล์เมื่อมีการยืนยันเอกสารแล้ว. อับโหลดรูปต่าง ๆ ได้ถึง 2 รูป และขนาดของไฟลล์จะต้องไม่เกิน 2 MB ต่อรูป",
                    pending_description_1: "ขอบคุณที่ท่านได้ส่งเอกสารต่าง ๆ เราจะทำการแจ้งให้ท่านทราบทางอีเมล์ในกรณีที่เรามีการอนุมัติ",
                    pending_description_2: "รีเฟรชหน้าเวปนี้เพื่อทำการอับเดทสถานะของการยืนยัน  ระยะเวลาที่ใช้ในการตรวจสอบข้อมูลคือ {{time}} ชั่วโมง",
                    approved_description: "บัญชีของคุณได้รับการยืนยันเป็นที่เรียบร้อยแล้ว คุณสามารถทำการสั่งสือรายการต่างๆ ในส่วนของเมนูที่ถูกจำกัดได้",
                    rejected_description: "บัตรประจำตัวของคุณถูกปฏิเสธ ถ้าหากว่าคุณประสงค์ที่จะลองอีกครั้ง กรุณาอับโหลดบัตรประจำตัวอีกครั้ง",
                    upload: "อับโหลดเอกสาร",
                    reupload: "อับโหลดเอกสารใหม่",
                    go_back: "กลับ",
                    view_document: "ดูเอกสาร {{number}}",
                    status: {
                        unverified: "ยกเลิกการยืนยัน",
                        pending: "กำลังรอการอนุมัติ",
                        approved: "ได้รับการยืนยันเรียบร้อยแล้ว",
                        rejected: "ปฎิเสธ",
                    },
                },
                headings: {
                    sessions: "จำนวนครั้ง",
                    orders: "รายการ",
                    spend: "จำนวนการสั่งซื้อ",
                    order_history: "ประวัติการสั่งซื้อ",
                    loyalty_points: "คะแนนความภักดี",
                },
            },
            custom_payment: {
                title: "{{name}} แบบฟอร์มการชำระเงิน",
                description: "คุณมาถึงหน้าของแบบฟอร์มการชำระเงินออนไลน์ของเรา โปรดกรอกรายละเอียดด้านล่างเพื่อชำระเงิน หากไม่ได้ป้อนจำนวนเงิน รายละเอียดของคุณจะถูกบันทึกแต่คุณจะไม่ถูกเรียกเก็บเงิน.",
                disabled: "หน้าการชำระเงินออนไลน์นี้ไม่ได้รับการกำหนดค่าอย่างถูกต้อง โปรดติดต่อเจ้าของไซต์เพื่อแก้ไขปัญหา",
                success: "การชำระเงินของคุณประสบความสำเร็จ รายละเอียดของคุณได้ถูกบันทำเป็นที่เรียบร้อยแล้ว ขอบคุณครับ",
                back: "กลับสู่หน้าแรก",
                fields: {
                    name: "ชื่อ และ นามสกุล",
                    email: "อีเมลล์",
                    reference: "หมายเลขอ้างอิงการชำระเงิน.",
                    amount: "จำนวน ($)",
                    name_on_card: "ฃื่อบนบัตรเครดิต",
                    submit: "ดำเนินการชำระเงิน",
                },
                warning: {
                    currency: "บันทึก: จำนวนเงินที่จะต้องชำระคือ {{actual}}, ไม่ใช่ {{default}}",
                },
                errors: {
                    generic: "มีปัญหาเกิดขึ้นบางประการ กรุณาลองใหม่ หรือ ติดต่อเราSomething went wrong, try again or contact us",
                    stripe_generic: "บัตรเครดิตการ์ดมีปัญหา กรุณารีเฟรชเวปหน้านี้แล้วลองใหม่",
                    payment_fail: "การชำระเงินไม่สำเร็จ กรุณาลองอีกครั้ง หรือ เลือกช่องทางการชำระเงินใหม่",
                    payment_cancelled: "การชำระเงินได้ถูกยกเลิก กรุณาลองใหม่ หรือเลือกช่องทางการชำระเงินใหม่",
                    payment_error: "การชำระเงินออนไลด์มีข้อผิดพลาด กรุณาเลือกช่องทางการชำระเงินใหม่",
                    payment_declined: "วิธีการชำระเงินของคุณล้มเหลว",
                    card_declined: "บัตรของคุณไม่ผ่าน ทางเราไม่สามารถดำเนินการต่อได้",
                    promo_max_uses_exceeded: "รหัสโปรโมชันนี้ถึงขีดจำกัดการใช้งานแล้วและไม่สามารถใช้ได้อีกต่อไป",
                },
            },
            dish: {
                add: "เพิ่มรายการ",
                edit: "อับเดทรายการ",
                notes: "ข้อกำหนดเป็นพิเศษ...",
                ingredients: {
                    title: "เครื่องปรุงต่าง ๆ",
                    uncheck_remove: "ไม่เลือก เพื่อทำการลบ",
                },
                ingredients_title: "เครื่องปรุง",
                combo: {
                    choose_dish: "เลือกอาหาร",
                },
                option_sets: {
                    conditions: {
                        select_one: "เลือกอย่างน้อย 1 รายการ (บังคับ)",
                        select_one_optional: "เลือก 1 รายการ (ไม่บังคับ)",
                        select_between: "เลือกระหว่างเวลา {{min}} - {{max}} (บังคับ)",
                        select_at_least: "ต้องเลือกอย่างน้อย {{qty}} (บังคับ)",
                        select_up_to: "เลือกได้ถึงจำนวน {{qty}} (ไม่บังคับ)",
                        select_multiple: "เลือกได้หลายรายการ (ไม่บังคับ)",
                        free_amount: "เริ่มแรก {{qty}} ฟรี / {{selected}} ถูกเลือกไปแล้ว",
                    },
                },
                error: "กรุณาแก้ไขตัวเลือกต่าง ๆ ที่เป็นสีแดง",
                added_to_cart: "อาหารจะถูกเพิ่มเข้าไปในรายการ",
            },
            map: {
                zone_fee: "ค่าส่ง",
                view_in_google: "ดูจาก Google Maps",
            },
            portal_go_back: {
                title: "ย้อมกลับไปที่หน้าค้นหาร้านอาหาร?",
                description: "รายการอาหารที่คุณลือกไว้จะสูญหาย",
                cancel: "ยกเลิก",
                proceed: "กลับ",
            },
            order: {
                config: {
                    services: {
                        title: "เลือกบริการ",
                        table_booking: "จองโต๊ะ",
                    },
                    address_custom: {
                        input_placeholder: "กรอกที่อยู่ของคุณ",
                    },
                    address: {
                        input_placeholder: "ค้นหาที่อยู่ที่จะไปส่งอาหาร",
                        extras_placeholder: "Unit number, building name, delivery instructions, etc...",
                        search_placeholder: "ค้นหาที่อยู่ขอบคุณ",
                        not_found: "ไม่เจอที่อยุ่ที่จะส่งอาหาร หรือ ที่อยู่ผิดพลาด กรุณากรอกที่อยู่ใหม่",
                        not_delivering: "ขออภัย เราไม่สามารถทำการจัดส่งอาหารไปที่อยู่นี้ได้ในขณะนี้",
                        not_in_range: "ที่อยู่ของคุณไม่ได้อยู่ในเขตที่อยู่ของร้านอาหารเรา",
                        not_in_zone: "ที่อยู่ของคุณไม่อยู่ในโซนที่เราจะทำการจัดส่งอาหารให้ได้",
                    },
                    datetime: {
                        title: "คุณต้องการสั่งอาหารเมื่่อไหร่",
                        due_now: "ในขณะนี้",
                        due_later: "ในภายหลัง",
                        service_not_available: "ขออภัยเราไม่สามารถรับออร์เดอร์สำหรับ {{service}} ได้ในขณะนี้",
                        currently_closed: "{{service}} ได้ปิดให้บริการในขณะนี้ กรุณาทำรายการใหม่ในภายหลัง",
                        due_unavailable: "ไม่ว่าง",
                        due_closed: "ปิด",
                        select_date: "เลือกวัน",
                        select_time: "เลือกเวลา",
                        select_order_date: "กรุณาเลือกวันที่ต้องการสั่งอาหาร",
                        select_order_time: "กรุณาเลือกเวลาที่ต้องการสั่งอาหาร",
                        select_booking_date: "กรุณาเลือกวันที่ต้องการจอง",
                        select_booking_time: "กรุณาเลือกเวลาที่ต้องการจอง",
                        no_times_available: "ไม่มีเวลาว่างที่สามารถเลือกได้",
                        date_today: "(วันนี้)",
                        date_closed: "(ปิด)",
                        date_bookings_paused: "(หยุดรับจองชั่วคราว)",
                        time_slot_closed: "ปิด",
                    },
                    number_of_people: {
                        placeholder: "จำนวนลูกค้า",
                    },
                    table: {
                        select: "เลือกโตัะ",
                        select_popup_title: "กรุณาเลือกโต๊ะ",
                        password: "ระหัสของโต๊ะ",
                        password_warning: "กรุณากรอกระหัสสำหรับโต๊ะของคุณเพื่อดำเนินการต่อ",
                    },
                    warning: {
                        closed: "ขออภัยทางร้านเราปิดในขณะนี้ / ไม่สามารถรับออเดอร์ใดๆ ได้",
                        not_available: "ขออภัยทางร้านไม่สามารถรับออเดอร์ต่าง ๆ ได้ ในขณะนี้",
                    },
                    start_button: "เริ่มต้นใหม่",
                },
                history: {
                    invalid: "ไม่สามารถทำการสั่งรายการดังกล่าวใหม่ได้เนื่องจากเมนูดังกล่าวอาจจะถูกแก้ไข หรือไม่มีอยู่แล้ว",
                },
                reorder: {
                    title: "การสั่งอาหารที่เคยสั่งแล้วได้อย่างรวดเร็ว",
                    description: "สั่งอาหารจากคำสั่งก่อนหน้าของคุณได้อย่างง่ายดาย",
                },
            },
            receipt: {
                errors: {
                    not_found: "ไม่พบรายการที่สั่ง กรุณารีเฟรชหน้าเวป แล้วลองสั่งใหม่อีกรอบ",
                    booking_not_found: "ไม่พบการจอง อาจถูกลบไปแล้ว",
                    generic: "มีความผิดพลาดบางประการเกิดขึ้น กรุณารีเฟรชหน้าเวป หรือติดต่อเรา",
                },
                connection: {
                    connected: "การอับเดทแบบ Real-time",
                    connecting: "การอับเดทแบบ Real-time กำลังทำการเชื่อมต่อ",
                    disconnected: "การอับเดทแบบ Real-time ได้ถูกยกเลิกแล้ว",
                },
            },
            warnings: {
                logout: {
                    pretitle: "เตือน",
                    title: "ออกจากระบบ",
                    body: "การออกจากระบบจะลบอาหารต่าง ๆ ที่คุณสั่งออกจากรายการอาหารของคุณ",
                    cancel: "ยกเลิก",
                    proceed: "ดำเนินการ",
                },
                order_restart: {
                    warning: "เตือน",
                    title: "เปลี่ยนแปลงรายละเอียดการสั่ง",
                    body: "เปลี่ยนรายละเอียดการสั่งอาหารของคุณจะมีผลให้รายการอาหารถูกลบออกจากการสั่ง เนื่องจากอาหารบางอย่างอาจไม่มีจำหน่าย",
                    cancel: "ยกเลิก",
                    proceed: "ดำเนินการ",
                },
                order_expired: {
                    subtitle: "สำคัญ",
                    title: "เงื่อนเวลาการสั่งซื้อได้ถูกเปลี่ยนให้เป็นต้องสั่งทันที",
                    description: "เวลาที่เลือกสำหรับการสั่งซื้อของคุณตอนนี้กำลังจะหมด ดังนั้นคำสั่งซื้อของคุณได้รับการแก้ไขให้ต้องทำการสั้งทันที / โดยเร็วที่สุด",
                    button: "ตกลง",
                },
                order_expiring: {
                    subtitle: "สำคัญ",
                    title: "กำหนดเวลาการสั่งซื้อใกล้จะหมดอายุในไม่ช้า",
                    description: "คุณจะต้องทำการสั่งอาหารก่อนเวลา {{time, timeFromTimestamp}} มิฉะนั้นการทำรายการดังกล่าวจะไม่สามารถทำได้",
                    button: "ตกลง",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "ลูกค้าที่ยังไม่ได้ลงทะเบียน",
                login: "เข้าสู่ระบบ",
                login_signup: "เข้าสู่ระบบ / ออกจากระบบ",
                logout: "ออกจากระบบ",
            },
            menus: {
                info: {
                    no_menus: "ไม่มีเมนูที่พร้อมใช้งานในขณะนี้",
                    restrictions: "เงื่อนไขของเมนู",
                    not_available: "ในขณะนี้ เมนูยังไม่พร้อมใช้งาน",
                    unavailable: {
                        times: "เมนูไม่สามารถใช้งานได้ การทำรายการของคุณไม่ตรงกับเงื่อนไขด้านล่างนี้",
                        services: "เมนูไม่สามารถใช้งานได้ การทำรายการของคุณไม่ตรงกับเงื่อนไขด้านล่างนี้",
                        hours: "เมนูไม่สามารถใช้งานได้ เวลาที่คุณสั่งอาหารไม่ใช่เวลาที่คุณสามารถสั่งรายการนี้ได้",
                        pre_order: "เมนูไม่สามารถใช้งานได้ การทำรายการสั่งอาหารของคุณไม่เข้าเงื่อนไขของการสั่งอาหารล่วงหน้า",
                        age: "เมนูไม่สามารถใช้งานได้ คุณจะต้องลงชื่อเข้าระบบทำการยื่นยันบัญชีของคุณเพื่อที่จะสามารถดำเนินการสั่งอาหารได้",
                    },
                    services: {
                        title: "เงื่อนไขในการสั่งอาหาร",
                        pickup: "มารับเอง",
                        delivery: "บริการส่ง",
                        dine_in: "รับประทานภายในร้าน",
                    },
                    times: {
                        now: "ไม่สามารถทำการสั่งล่วงหน้าได้",
                        later: "ต้องทำการสั่งล่วงหน้าเท่านั้น",
                    },
                    hours: {
                        title: "เวลาที่สามารถทำได้",
                    },
                    preorder: {
                        title: "เงื่อนไขการทำรายการสั่งล่วงหน้า",
                        days_in_advance: "จะต้องสั่งของลา {{days}} วัน",
                        cutoff_time: "วันสุดท้ายและเวลาที่มีการจำกัดการสั่งของ {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "การจำกัดอายะ",
                        approved: "บัญชีของคุณได้รับการยืนยันแล้วและคุณสามารถสั่งซื้อได้จากเมนูนี้",
                        rejected: "ต้องมีการตรวจสอบอายุเพื่อสั่งซื้อ สร้างบัญชีและอัปโหลดบัตรประจำตัวของคุณ",
                    },
                },
            },
            info: {
                location: {
                    title: "สถานที่ตั้น",
                    view_map: "ดูแผนที่",
                    phone: "หมายเลขโทรศัพท์",
                },
                hours: {
                    title: "เวลาเปิดทำการ",
                    title_special: "เวลาเปิดทำการพิเสษ",
                },
                services: {
                    title: "บริการ",
                    notes: "หมายเหตุ",
                    delivery: {
                        ranges: "ช่วงของการจัดส่ง",
                        zones: "เขตที่จะทำการจัดส่ง",
                        view_zones: "ดูเวลาจากแผนที่",
                        fee: "ค่าจัดส่ง",
                        fee_short: 'ค่าจัดส่ง',
                        fee_varies: "จำนวนต่าง ๆ, แสดงในรายการสั่งซื้อ",
                        min_order: "จำนวนที่ต้องสั่งขึ้นต่ำ",
                        min_order_short: 'ขั้นต่ำ',
                        no_min_order: "ไม่ต้องมีการสั่งอาหารขึ้นต่ำ",
                        free_amount: "จำนวนที่สามาถทำจัดส่งให้ฟรี",
                    },
                },
            },
            contact: {
                title: "ติดต่อเรา",
                name: "ชื่อ",
                email: "อีเมลล์",
                phone: "หมายเลขโทรศัพท์",
                message: "กรุณาพิมพ์ข้อความ...",
                send: "ส่งข้อความ",
                success: "ข้อความขอบคุณได้ถูกส่งเป็นที่เรียบร้อยแล้ว",
                error: "มีข้อผิดพลาดบางประการเกิดขึ้น กรุณาลองใหม่ในภายหลัง",
            },
            footer: {
                powered_by: "ให้บริการโดย",
                terms_and_conditions: "ข้อกำหนดและเงื่อนไข",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'ใบในการจอง',
            details: {
                datetime: 'การจองสำหรับ',
                number_of_people: 'จำนวนลูกค้า',
                placed: 'ถูกสั่ง',
                updated: 'การอับเดทล่าสุด',
                notes: 'หมายเหตุ',
                name: 'ฃื่อ',
                email: 'อีเมลล์',
                phone: 'หมายเลขโทรศัพท์',
                store_address: 'ที่อยู่ร้านอาหาร',
            },
            status_update: {
                title: 'การจอง {{number}} ได้ถูกอับเดทแล้ว',
                body: 'สถานะของการจองของคุณได้รับการอับเดทเป็น {{status}}',
            },
            email_status_update_customer: {
                subject: 'การจอง #{{number}} – {{subjectLabel}}',
                body: 'การจอง #{{number}} ของคุณที่ {{store}} เป็น {{status}} แล้ว',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'คำสั่งซื้อ #{{number}} – {{subjectLabel}}',
        header: 'เวลาพร้อมรับที่อัปเดต',
        title: 'เวลาพร้อมรับที่อัปเดต',
        order_number: 'หมายเลขคำสั่งซื้อ: {{number}}',
        description: 'คำสั่งซื้อของคุณจะพร้อมในเวลา {{time}}',
        order_time_updated_to: 'เวลาคำสั่งซื้อของคุณได้รับการอัปเดตแล้ว',
        powered_by: 'ขับเคลื่อนโดย {{name}}',
        button_text: 'ติดตามการสั่งซื้อ',
        subject_label: 'เวลาพร้อมรับที่อัปเดต',
        subject_label_delivery: 'เวลาจัดส่งที่อัปเดต',
        body_ready: 'คำสั่งซื้อของคุณจะพร้อมในเวลา {{time}}',
        body_delivery: 'คำสั่งซื้อของคุณจะถูกจัดส่งในเวลา {{time}}',
    },
    order: {
        receipt: {
            est_ready_time: 'เวลาที่อาหารเสร็จ โดยประมาณ',
            est_driver_pickup_time: 'เวลาที่คนขับจะมารับอาหารโดยประมาณ',
            est_delivery_time: 'เวลาจัดส่งโดยประมาณ',
            tab_details: 'รายละเอียด',
            tab_dishes: 'รายการอาหาร',
            details: {
                status: 'สถานะ',
                placed: 'ถูกสั่ง',
                due: 'ถึงกำหนด',
                due_asap: 'เดี๋ยวนี้ / เร็วที่สุดเท่าที่จะทำได้',
                last_updated: 'อับเดทครั้งล่าสุด',
                total: 'รวมทั้งสิ้น',
                type: 'ชนิด',
                table: 'โต๊ะ',
                number_of_people: 'จำนวนลูกค้า',
                payment_method: 'วิธีการชำระเงิน',
                payment_status: 'สถานะการชำระเงิน',
                payment_currency: 'สกุลเงินที่ใช้',
                notes: 'หมายเหตุ',
                name: 'ชือ',
                email: 'อีเมลล์',
                phone: 'หมายเลขโทรศัพท์',
                distance: 'ระยะทาง',
                driving_time: 'ระยะเวลาในการขัดรถ',
                delivery_zone: 'โซน',
                delivery_address: 'ที่อยู่ในการจัดส่ง',
                delivery_tracking: 'ติดตามการจัดส่ง',
                delivery_tracking_link: 'ดูลิงค์เพื่อติดตามผลแบบ Real-time',
                tookan_status: 'สถานะของ Tookan',
                tookan_status_failed_book: 'ไม่สามารถจองเพื่อให้ทำการจัดส่งได้',
                tookan_status_failed_update: 'ไม่สามารถอับเดทการจองได้',
                tookan_status_success: 'ทำการสั่งอาหารเพื่อให้ไปส่ง',
                store_address: 'ที่อยู่ร้านอาหาร',
            },
            dishes: {
                headings: {
                    quantity: 'จำนวน',
                    item: 'รายการ',
                    price: 'ราคา',
                },
                notes: 'หมายเหตุ',
                remove_ingredients: 'เครื่องปรุงที่ไม่ต้องการ',
            },
            status_update: {
                title: 'รายการสั่งอาหารเลขที่ {{number}} ได้ถูกอับเดทแล้ว',
                body: 'Your order status has been updated to {{status}}',
            },
            wait_time_update: {
                title: 'รายการสั่งอาหารเลขที่ {{number}} ได้ถูกอับเดทแล้ว',
                body: 'เวลาที่ออร์เดอร์ของคุณจะแล้วเสร็จได้ถูกอับเดทแล้ว',
            },
            delivery_update: {
                title: 'รายการสั่งอาหารเลขที่ {{number}} ได้ถูกอับเดทแล้ว',
                body: 'การสั่งซื้อของคุณกำลังอยู่ในกระบวนการจัดส่ง ดูลิงค์เพื่อติดตามผลแบบ Real-time',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "ติดตามการสั่งซื้อ",
                track_delivery_button_text: "ติดตามการจัดส่ง",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "ติดตามการสั่งซื้อ",
                track_delivery_button_text: "ติดตามการจัดส่ง",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) inc. in price",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "ค่าจัดส่ง",
            promo: "ส่วนลด: {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "ส่วนลด: {{name}} ({{percent}}%)",
            promo_fixed: "ส่วนลด: {{name}}",
            promo_none: "ส่วนลด: {{name}}",
            cart: "รายการ",
            tip: "ค่า ทริป",
            total: "ยอดรวม",
        },
        status: {
            unconfirmed: "ยังไม่ได้รับการยืนยัน",
            awaiting_payment: "รอการชำระเงิน",
            confirmed: "ถูกยืนยัน",
            ready: "เรียบร้อยแล้ว",
            on_route: "กำลังดำเนินการ",
            complete: "เสร็จแล้ว",
            cancelled: "ยกเลิก",
            seated: "นั่งแล้ว",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "ไม่มี",
                },
            },
            dish: {
                no_stock: "สินค้าหมด",
                not_available: "ไม่มีจำหน่าย",
            },
        },
    },
};
//# sourceMappingURL=th.js.map